import VendorCard from "@molecules/ObjectCard/ObjectCards/VendorCard/VendorCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function VendorCardsView() {
    return (
        <CardsView.List<Vendor>>
            {(vendor, displayedAttributes) => <VendorCard vendor={vendor} displayedAttributes={displayedAttributes} />}
        </CardsView.List>
    )
}
